export function dateToStr(dateObj: Date): string {
    let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    let day = String(dateObj.getDate()).padStart(2, '0');
    let year = dateObj.getFullYear();
    let output = `${day}/${month}/${year}`;
    return output;
}